// extracted by mini-css-extract-plugin
module.exports = {"add-client-button":"_1WNrGN6DdVa9mfMqLeCkZf","preLoaderShimmer":"_1btQAS56hzZSkR-VyhaflK"};